import HeadSectionComponent from "./HeadSection";

export default HeadSectionComponent